import React, { useEffect, useState, useLayoutEffect } from 'react';
import {Platform, Dimensions, Text, View, ScrollView, SafeAreaView, StyleSheet, Button, Alert, FlatList,StatusBar } from 'react-native'
import { useRoute } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import { Video, AVPlaybackStatus } from 'expo-av';
import Constants from 'expo-constants';
import * as ScreenOrientation from 'expo-screen-orientation';
import { useNavigation } from '@react-navigation/native';
//Firebase
import { database } from '../database/firebase';
import { collection, doc, getDoc, addDoc, query, orderBy, onSnapshot } from 'firebase/firestore';


//My components
import Header from './Header';
import Footer from './Footer';
import SituaInfoCard from './cards/SituaInfoCard';
import CuadroTema from './cards/CuadroTema';


//import SwiperImage from './Carousel/SwiperImage'


const videominheight = 400;

const Situacion = () => {

  const { params: {
    nombre,
    codigo,
    location,
    tags
  }} = useRoute();

  const navigation = useNavigation();
  useLayoutEffect(() => {
      navigation.setOptions({
          headerShown: false,
      });
      console.log("image");
      //console.log(matconlogo);
  }, []);

  const tailwind = useTailwind();

  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  

  async function getMain() {
    console.log("Database");
    console.log(database);

    console.log("get the data")
    console.log("codigo " + codigo)
    const docRef = doc(database, "Situaciones2", codigo);
    const docSnap = await getDoc(docRef);
    console.log("data is")
    console.log(docSnap);
    console.log(docSnap.data())

    setData(docSnap.data())
  }

  useEffect(() => {

    getMain().then( () => setLoading(false));

  }, []);

//flex justify-center p-8
//<View style={styles.title}><Text>Viendo Situación: { nombre["esp"] }</Text></View>

  return (
    <SafeAreaView style ={ styles.container }> 
      <Header/>
      <ScrollView style={ tailwind("bg-white") }>
        {isLoading ? <Text>Loading...</Text> : 
          <View>
              <SituaInfoCard
                  codigo={data["codigo"]}
                  titulo={data["titulo"]}
                  descripcion={data["descripcion"]}  
                  multimedia={data["multimedia"]}  
                  ejes={data["ejes"]}
                  tags={data["etiquetas"]}
                  pagimod = {data["pagimod"]}
              /> 
            <View style ={ tailwind("mt-8 flex flex-row flex-wrap justify-evenly") } >
            {
              data["cuadrotema"].map((cuadrotema) => {
                return (
                  <CuadroTema
                    titulo={ cuadrotema["titulo"] }
                    descripcion={ cuadrotema["descripcion"] }
                    color={ cuadrotema["color"] }
                    contenido = { cuadrotema["contenido"] }
                  />
                )
              })
            }
            </View>
          </View>
        }
        <Footer/>
        
      </ScrollView>
    </SafeAreaView>
  );
};
  
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      marginTop:StatusBar.currentHeight //+20
   },
  })
  
  export default Situacion